var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-square",class:_vm.classModificator ? `button-square_${_vm.classModificator}` : '',attrs:{"disabled":_vm.disabled}},[(!_vm.hideIcon)?_c('svg-icon',{staticClass:"button-square__icon",attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }